export default __webpack_public_path__ + "static/media/checkmark-circle-icon.7840cb92.svg";